import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {DateTime} from "luxon";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {LavoratoreCalcolo} from "@commons/services/presenze_calcolo/Calcolo";
import {TipoCausaleWF} from "@commons/mapping/CausaleWFRecord";

type Lavoratore = Pick<LavoratoreCalcolo, 'codDip' | 'descrizione' | 'cognome' | 'nome' | 'dataCessazione' | 'status'>

export class CausaliWF {
    private readonly lavoratore: Lavoratore;
    private readonly causaliWF: PresenzeCausaleWFRecord[];
    private readonly causaliWFElaborate: string[]; // idWF elaborati
    private readonly cache: CachePresenze;
    private readonly giornataBloccataConWF: boolean;

    constructor(lavoratore: Lavoratore, causaliWF: PresenzeCausaleWFRecord[], causaliWFElaborate: string[] = [], cache: CachePresenze, giornataBloccataConWF: boolean) {
        this.lavoratore = lavoratore;
        this.causaliWF = causaliWF;
        this.causaliWFElaborate = causaliWFElaborate;
        this.cache = cache;
        this.giornataBloccataConWF = giornataBloccataConWF;
    }

    public getCausaliWFElaborate = () => this.causaliWFElaborate;
    /**
     *
     * @param tipoCausale puo' valere ORE_MANCANTI, ORE_ECCEDENTI o QUANTITA
     * @param day l'oggetto presenza giornate
     * @param mancante in minuti
     * @param rilevaMancante funzione per il calcolo del mancante
     * @param checkMancanteGiustificato true/false verifica mancante giustificato da WF, se true non viene inserito nulla ma viene quantificato il mancante gestito dalle causali di WF
     * @returns {*} mancante in minuti
     */
    public applica = (tipoCausale: TipoCausaleWF, day: PresenzeGiornataPlusRecord, mancante: number, rilevaMancante: null | (() => number), checkMancanteGiustificato: boolean):
        { mancante: number, ricalcola: boolean, numCausaliEccedenti: number } => {
        const dtGiornata = DateTime.fromISO(day.dtGiornata!);
        let numCausaliEccedenti = 0;
        let ricalcola = false;
        if (this.causaliWF.length > 0) {
            let countElab = 0;
            const newCausaliHH = []; // PresenzeCausali
            const newCausaliQI = []; // PresenzeCausali
            for (let indCausale = 0; indCausale < this.causaliWF.length; ++indCausale) {
                if (day.dtGiornata === this.causaliWF[indCausale].giornoDt) {

                    const causaleWF = this.causaliWF[indCausale];
                    if (causaleWF.wf.stato === 'ACCETTATA' && !causaleWF.wf.annullata) {
                        if (tipoCausale === causaleWF.causaleWF!.tipoCausale) {
                            if (!causaleWF.elaborato // Elaborato in precedenti calcoli già salvati e ricaricati
                                //&& (DateTime.fromISO(causaleWF.giornoDt!) === dtGiornata)
                                && this.causaliWFElaborate.findIndex(key => key === PresenzeCausaleWFRecord.getKey(causaleWF)) === -1 // Elaborato in precedenti calcoli e non ancora salvati e ricaricati
                            ) {
                                if (!checkMancanteGiustificato && tipoCausale === 'ORE_MANCANTI' && countElab > 0) {
                                    ricalcola = true; // In caso di ore mancanti, elaboro solo una richiesta alla volta e forzo ricalcolo!
                                    break;
                                }
                                // todo per gestione legge 104 e in generale per causali che possono essere legate a piu' giustificativi:
                                // a partire da una singola richiesta vengono generati tanti records quanti sono gli agganci tra richiesta e giustificativi!
                                // aggancio dovrebbe diventare un array...
                                // N.B. Se status non presente nella giornata in esame, l'aggancio non viene valorizzato!
                                if (causaleWF.aggancio !== null && causaleWF.aggancio.codGiu !== null && causaleWF.aggancio.codGiu !== '') {
                                    countElab = countElab + 1;
                                    if (causaleWF.giornataIntera) {
                                        causaleWF.quantita = RiepilogoOrePlus.getTotaleHPrev(day.totali) / 60;
                                    }

                                    // Controllo applicabilità da status e giornata compatibile!!! - INIZIO
                                    const giu = this.cache.getGiustificativo(causaleWF.aggancio.codGiu);
                                    const elencoStatus = LavoratorePresenzeRecord.getStatus(this.lavoratore, day.dtGiornata);
                                    let addGiu = GiustificativoRecord.hasStatus(giu!, elencoStatus) &&
                                        GiustificativoRecord.isDayCompliance(giu!, day) &&
                                        GiustificativoRecord.isGMCompliance(giu!, day);
                                    const causale = PresenzeGiustificativo.factory({codGiu: giu!.codGiu!, tipoGiu: GiustificativoRecord.getTipoGiu(giu!)});
                                    /*var addGiu = (giu.status.length === 0);
                                    for (let indStatus = 0; !addGiu && indStatus < giu.status.length; ++indStatus) {
                                        var codStatus = giu.status[indStatus].id;
                                        for (let indFiltroStatus = 0; indFiltroStatus < this.elencoStatus.length; ++indFiltroStatus) {
                                            if (this.elencoStatus[indFiltroStatus].codice === codStatus) {
                                                addGiu = true;
                                            }
                                        }
                                    }*/
                                    // Controllo applicabilità da status e giornata compatibile!!! - FINE

                                    if (addGiu) {
                                        switch (causaleWF.causaleWF!.tipoCausale) {
                                            case 'ORE_MANCANTI':
                                                if (!this.giornataBloccataConWF && !checkMancanteGiustificato && causaleWF.causaleWF!.azioneMancante === 'MANCANTE_WFM') {
                                                    let mancanteHHCC = mancante / 60;
                                                    if (causaleWF.quantita > mancanteHHCC) {
                                                        mancanteHHCC = GiustificativoRecord.ageduaQuantitaOraria(giu!, mancanteHHCC);
                                                        if (mancanteHHCC > mancante) { // Se la quantità adeguata è comunque superiore al mancante
                                                            PresenzeGiornataPlusRecord.setWarning(day, 1024); // Giustificativo da workflow non applicabile!
                                                            addGiu = false;
                                                        } else {
                                                            switch (causaleWF.causaleWF!.azioneQuantitaNonCoincidenti) {
                                                                case 'SET_OK':
                                                                    PresenzeGiustificativo.setHHCC(causale, mancanteHHCC);
                                                                    break;
                                                                case 'SET_WARNING':
                                                                    PresenzeGiustificativo.setHHCC(causale, mancanteHHCC);
                                                                    PresenzeGiornataPlusRecord.setWarning(day, 512);
                                                                    break;
                                                                case 'UNSET_ERROR':
                                                                    addGiu = false;
                                                                    break;
                                                            }
                                                        }
                                                    } else {
                                                        PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                    }
                                                } else {
                                                    PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                    if (checkMancanteGiustificato) {
                                                        mancante += (causaleWF.quantita * 60.0); // Quantifico mancante per gestione "con o senza timbrature"
                                                    }
                                                }
                                                break;
                                            case 'ORE_ECCEDENTI':
                                                if (causaleWF.causaleWF!.azioneEccedente === 'COME_WF') {
                                                    PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                } else if (!this.giornataBloccataConWF && causaleWF.causaleWF!.azioneEccedente === 'ECCEDENTE') {
                                                    PresenzeGiustificativo.setHHCC(causale, day.totali!.hEccDiurne / 60);
                                                } else if (!this.giornataBloccataConWF && causaleWF.causaleWF!.azioneEccedente === 'ECCEDENTE_WFM') {
                                                    const eccedenteHHCC = day.totali!.hEccDiurne / 60;
                                                    if ((causaleWF.quantita) > eccedenteHHCC) {
                                                        switch (causaleWF.causaleWF!.azioneQuantitaNonCoincidenti) {
                                                            case 'SET_OK':
                                                                PresenzeGiustificativo.setHHCC(causale, eccedenteHHCC);
                                                                break;
                                                            case 'SET_WARNING':
                                                                PresenzeGiustificativo.setHHCC(causale, eccedenteHHCC);
                                                                PresenzeGiornataPlusRecord.setWarning(day, 8192);
                                                                break;
                                                            case 'UNSET_ERROR':
                                                                addGiu = false;
                                                                break;
                                                        }
                                                    } else {
                                                        PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                    }
                                                } else {
                                                    PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                }
                                                break;
                                            case 'QUANTITA':
                                                switch (causaleWF.causaleWF!.azioneQuantitaNonCoincidenti) {
                                                    case 'SET_QUANTITA':
                                                    case 'SET_DEFAULT':
                                                        PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                        break;
                                                    case 'SET_DEFAULT_E_WARNING':
                                                        PresenzeGiustificativo.setHHCC(causale, causaleWF.quantita);
                                                        PresenzeGiornataPlusRecord.setWarning(day, 4096);
                                                        break;
                                                }
                                                break;
                                        }

                                        if (addGiu && !checkMancanteGiustificato) {
                                            causale.idWF = causaleWF.wf.idWF;
                                            if (causale.tipoGiu === 'ORARIO') {
                                                newCausaliHH.push(causale);
                                            } else {
                                                newCausaliQI.push(causale);
                                            }
                                            this.causaliWFElaborate.push(PresenzeCausaleWFRecord.getKey(causaleWF));
                                        }
                                    } else {
                                        // N.B. non entrerà mai per lo status, mentre verrà eseguito nei casi di !giu.isDayCompliance(day) o !giu.isGMCompliance(day)
                                        // Non per lo status per il motivo di cui sopra, non valorizza l'aggancio se manca lo status!
                                        PresenzeGiornataPlusRecord.setWarning(day, 1024); // Giustificativo da workflow non conforme ad alcun status!
                                    }
                                } else {
                                    // aggancio non valido!
                                    PresenzeGiornataPlusRecord.setWarning(day, 1024);
                                    console.log("aggancio non valido!");
                                }
                            }
                        }
                    }
                } // fine causale per la giornata in esame
            } // fine for

            if (!checkMancanteGiustificato) {
                let count: number;
                count = PresenzeGiornataPlusRecord.addCausaliHH(day, newCausaliHH, GestionePlus.maxCausaliOre);
                this.checkOverflowGiu(day, count, newCausaliHH);
                if (rilevaMancante !== null) {
                    if (count > 0) {
                        mancante = rilevaMancante();
                        if (mancante === 0) {
                            PresenzeGiornataPlusRecord.setAnomalia(day, -3);
                        }
                    }
                }

                if (tipoCausale === 'ORE_ECCEDENTI') {
                    numCausaliEccedenti = count; // Restituisco il numero di causali caricate... Utile per determinare il caricamento delle eccedenti.
                }

                count = PresenzeGiornataPlusRecord.addCausaliQI(day, newCausaliQI, GestionePlus.maxCausaliQI);
                this.checkOverflowGiu(day, count, newCausaliQI);
            }
        }

        return {mancante: mancante, ricalcola: ricalcola, numCausaliEccedenti: numCausaliEccedenti};
    };

    public hasWorkflow4day = (_day: PresenzeGiornataPlusRecord) => {
        return false;
    };

    /**
     * Controlla se è stato superato il numero massimo di giustificativi inseribili per giornata; in tal caso set anomalia
     * @param day giorno in elaborazione
     * @param count numero giustificativi inseriti
     * @param newCausali array giustificativi da inserire
     */
    private checkOverflowGiu = (day: PresenzeGiornataPlusRecord, count: number, newCausali: PresenzeGiustificativo[]) => {
        if (count < newCausali.length) {
            console.error(LavoratorePresenzeRecord.getDescrizione(this.lavoratore), GestionePlus.formatDate(day.dtGiornata), 'Raggiunto il limite massimo di causali!');
            PresenzeGiornataPlusRecord.setAnomalia(day, 11);
        }
    };
}